
function fhClearCartOnNewSession(callback) {
  var alreadyCleared = false;
  try {
    alreadyCleared = sessionStorage.getItem('fh_session_started') === '1';
  } catch (e) {
    alreadyCleared = false;
  }

  if (alreadyCleared) {
    callback();
    return;
  }

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
  })
    .catch(function (err) { console.error('Cart clear on new session failed', err); })
    .finally(function () {
      try { sessionStorage.setItem('fh_session_started', '1'); } catch (e) {}
      callback();
    });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fh-buybox').forEach(initBuyBox);
  initCartDrawerGlobal();
  fhClearCartOnNewSession(function () {
    refreshCartDrawer();
  });
});

var FH_COLOR_MAP = {
  'night sky': { accent: '#ffffff', text: '#000000' },
  'black': { accent: '#ffffff', text: '#000000' },
  'scarlet red': { accent: '#e63946', text: '#ffffff' },
  'red': { accent: '#e63946', text: '#ffffff' },
  'sapphire blue': { accent: '#2563eb', text: '#ffffff' },
  'blue': { accent: '#2563eb', text: '#ffffff' }
};

function initCartDrawerGlobal() {
  var overlay = document.getElementById('fh-cart-overlay');
  var drawer = document.getElementById('fh-cart-drawer-global');
  var closeBtn = document.getElementById('fh-cart-close');
  var cartToggles = document.querySelectorAll('.fh-cart-toggle');
  if (!overlay || !drawer) return;

  function openDrawer() {
    overlay.hidden = false; drawer.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    });
  }
  function closeDrawer() {
    overlay.classList.remove('is-visible');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    setTimeout(function () { overlay.hidden = true; drawer.hidden = true; }, 350);
  }

  cartToggles.forEach(function (btn) { btn.addEventListener('click', openDrawer); });
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  window.fhOpenCartDrawer = openDrawer;
}

function bumpCartCount() {
  document.querySelectorAll('.fh-cart-count').forEach(function (el) {
    el.classList.add('fh-bump');
    setTimeout(function () { el.classList.remove('fh-bump'); }, 250);
  });
}

function removeCartLine(lineKey, itemEl) {
  if (itemEl) itemEl.classList.add('is-removing');
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: 0 })
  })
    .then(function (res) { return res.json(); })
    .then(function () {
      bumpCartCount();
      refreshCartDrawer();
    })
    .catch(function (err) {
      console.error('Remove failed', err);
      if (itemEl) itemEl.classList.remove('is-removing');
    });
}

function buildCartItemRow(item) {
  var row = document.createElement('div');
  row.className = 'fh-cart-drawer-item';
  row.innerHTML =
    '<img src="' + item.image + '" alt="' + item.product_title + '">' +
    '<div class="fh-cart-drawer-item__details">' +
      '<p class="fh-cart-drawer-item__title">' + item.product_title + '</p>' +
      '<p class="fh-cart-drawer-item__variant">' + item.variant_title + '</p>' +
      '<div class="fh-cart-drawer-item__qty-row"><span>Qty: ' + item.quantity + '</span></div>' +
    '</div>' +
    '<div style="display:flex;flex-direction:column;align-items:end;gap:8px;">' +
      '<p class="fh-cart-drawer-item__price">$' + (item.final_line_price / 100).toFixed(2) + '</p>' +
      '<button type="button" class="fh-cart-drawer-item__remove" data-line-key="' + item.key + '">Remove</button>' +
    '</div>';
  row.querySelector('.fh-cart-drawer-item__remove').addEventListener('click', function () {
    removeCartLine(item.key, row);
  });
  return row;
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.fh-cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      var body = document.getElementById('fh-cart-drawer-global__body');
      var subtotalEl = document.getElementById('fh-cart-subtotal');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<p class="fh-cart-drawer-global__empty">Your cart is empty.</p>';
        if (subtotalEl) subtotalEl.textContent = '$0.00';
        return;
      }

      body.innerHTML = '';

      var blocks = [];
      cart.items.forEach(function (item) {
        var bundleId = item.properties && item.properties['_bundle_id'];
        var lastBlock = blocks[blocks.length - 1];
        if (bundleId) {
          if (lastBlock && lastBlock.type === 'bundle' && lastBlock.bundleId === bundleId) {
            lastBlock.items.push(item);
          } else {
            blocks.push({
              type: 'bundle',
              bundleId: bundleId,
              label: item.properties['_bundle_label'] || 'Bundle',
              items: [item]
            });
          }
        } else {
          blocks.push({ type: 'single', items: [item] });
        }
      });

      blocks.forEach(function (block) {
        if (block.type === 'bundle') {
          var groupEl = document.createElement('div');
          groupEl.className = 'fh-cart-bundle-group';
          groupEl.innerHTML =
            '<div class="fh-cart-bundle-group__header">' +
              '<span class="fh-cart-bundle-group__badge">Bundle</span>' +
              '<span class="fh-cart-bundle-group__label">' + block.label + '</span>' +
            '</div>';
          block.items.forEach(function (item) {
            groupEl.appendChild(buildCartItemRow(item));
          });
          body.appendChild(groupEl);
        } else {
          var wrap = document.createElement('div');
          wrap.className = 'fh-cart-line-block';
          wrap.appendChild(buildCartItemRow(block.items[0]));
          body.appendChild(wrap);
        }
      });

      if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
    })
    .catch(function (err) { console.error('Cart refresh failed', err); });
}

function initBuyBox(root) {
  var productId = root.dataset.productId;
  var scriptTag = document.getElementById('fh-variant-data-' + productId);
  if (!scriptTag) return;
  var variants = JSON.parse(scriptTag.textContent);

  var selections = {};
  var colorOptionIndex = null;
  root.querySelectorAll('.fh-option-group').forEach(function (group) {
    var index = group.dataset.optionIndex;
    var activePill = group.querySelector('.fh-pill.is-active');
    selections[index] = activePill ? activePill.dataset.value : null;
    if (group.querySelector('.fh-pill--swatch')) {
      colorOptionIndex = index;
    }
  });

  function applyAccentColor(colorValue) {
    if (!colorValue) return;
    var key = colorValue.toLowerCase().trim();
    var match = FH_COLOR_MAP[key];
    if (!match) {
      Object.keys(FH_COLOR_MAP).forEach(function (k) {
        if (key.indexOf(k) !== -1) match = FH_COLOR_MAP[k];
      });
    }
    if (match) {
      root.style.setProperty('--fh-accent', match.accent);
      root.style.setProperty('--fh-accent-text', match.text);
    }
  }

  function updateVariant() {
    var match = variants.find(function (v) {
      return Object.keys(selections).every(function (idx) {
        var optKey = 'option' + (parseInt(idx, 10) + 1);
        return v[optKey] === selections[idx];
      });
    });
    var hiddenInput = root.querySelector('#fh-selected-variant-id');
    if (match && hiddenInput) {
      hiddenInput.value = match.id;
      var priceEl = root.querySelector('.fh-price__current');
      if (priceEl) priceEl.textContent = '$' + (match.price / 100).toFixed(2);
      var submitBtn = root.querySelector('#fh-add-to-cart');
      if (submitBtn) submitBtn.disabled = !match.available;
    }
    if (colorOptionIndex !== null) {
      applyAccentColor(selections[colorOptionIndex]);
    }
  }

  root.querySelectorAll('.fh-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var group = pill.closest('.fh-option-group');
      group.querySelectorAll('.fh-pill').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      selections[group.dataset.optionIndex] = pill.dataset.value;
      updateVariant();
    });
  });

  var qtyInput = root.querySelector('#fh-qty-input');
  root.querySelectorAll('.fh-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (btn.dataset.action === 'increase') val += 1;
      if (btn.dataset.action === 'decrease' && val > 1) val -= 1;
      qtyInput.value = val;
    });
  });

  var form = root.querySelector('#fh-product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = root.querySelector('#fh-add-to-cart');
      if (submitBtn) submitBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) { return res.json().then(function (err) { throw err; }); }
          return res.json();
        })
        .then(function () {
          if (submitBtn) {
            submitBtn.classList.remove('is-loading');
            submitBtn.classList.add('is-success');
            setTimeout(function () { submitBtn.classList.remove('is-success'); }, 500);
          }
          bumpCartCount();
          refreshCartDrawer();
          if (window.fhOpenCartDrawer) window.fhOpenCartDrawer();
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          if (submitBtn) submitBtn.classList.remove('is-loading');
          alert(err.description || 'Could not add to cart. Please select all options.');
        });
    });
  }

  updateVariant();
}
